import { render, staticRenderFns } from "./LayoutNews.vue?vue&type=template&id=b31b12f6&"
import script from "./LayoutNews.vue?vue&type=script&lang=js&"
export * from "./LayoutNews.vue?vue&type=script&lang=js&"
import style0 from "./LayoutNews.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports